module.exports = __webpack_public_path__ + "img/cyberlook.a3ea4977.png";